/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Evidence_SupportedInputs */

const en_directory_evidence_supported = /** @type {(inputs: Directory_Evidence_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified`)
};

const zh_directory_evidence_supported = /** @type {(inputs: Directory_Evidence_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已验证`)
};

/**
* | output |
* | --- |
* | "Verified" |
*
* @param {Directory_Evidence_SupportedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_evidence_supported = /** @type {((inputs?: Directory_Evidence_SupportedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Evidence_SupportedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_evidence_supported(inputs)
	return zh_directory_evidence_supported(inputs)
});
export { directory_evidence_supported as "directory.evidence.supported" }